import * as React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { cityIn } from 'lvovich';

import { getDurationString } from '../../Results/utils';
import { Duration } from '../../types';
import { SegmentFragment } from '@websky/graphql';
import { EngineTheme, useMergeClasses, useTheme } from '../../theme';
import { ArrowForward } from '../../Icons';

interface Props {
	className?: string;
	classes?: EngineTheme['TransferInfo']['TransferInfo'];
	showStops?: boolean;
	segment: SegmentFragment;
	nextSegment: SegmentFragment;
	transferDuration: Duration;
}

const TransferInfo: React.FunctionComponent<Props> = ({
	className,
	classes,
	segment,
	nextSegment,
	transferDuration,
	showStops
}) => {
	const { t } = useTranslation();
	const { TransferInfo: defaultClasses } = useTheme('TransferInfo');
	const css = useMergeClasses(defaultClasses, classes);

	return (
		<div className={cn(css.transfer, className)}>
			{showStops && !!segment.stops?.length && (
				<span className={cn(css.warning, css.technicalLandingIn)}>
					{t('DesktopFlightInfo:TechnicalLandingIn', {
						count: segment.stops?.length
					})}{' '}
					{segment.stops?.map(stop => cityIn(stop?.airport?.city?.name)).join(', ')}
				</span>
			)}

			{transferDuration && (
				<span className={css.transfer__layover}>
					{t('TransferInfo:layover')} {cityIn(segment.arrival.airport.city.name)}:&nbsp;
					{getDurationString(transferDuration)}
				</span>
			)}

			{nextSegment && segment.arrival.terminal !== nextSegment.departure.terminal && (
				<span className={css.warning}>
					{t('TransferInfo:Change')} {t('TransferInfo:Terminal')} {segment.arrival.terminal}
					<span className={css.warning__icon}>{ArrowForward}</span>
					{t('TransferInfo:Terminal')} {nextSegment.departure.terminal}
				</span>
			)}
		</div>
	);
};

export default TransferInfo;
